import React from 'react'

import { Typography } from '@smarty-nx/ds'
import { TRACKING_CATEGORIES } from '@smarty-nx/tracking'

import { content } from './content'
import styles from './index.module.scss'
import { FEATURES } from '../../config'
import GenesysIcon from '../../static/images/icons/genesys-webchat.svg'
import IntercomIcon from '../../static/images/icons/intercom-webchat.svg'
import { PromiseGenesys } from '../../utils/genesys'
import Button from '../Button'

const chatButtonProps = {
  'data-item-category': TRACKING_CATEGORIES.CONTACT,
  'data-item-name': content.dataItemName,
  'data-testid': 'email-button',
  onClick: FEATURES.GENESYS
    ? () => PromiseGenesys('command', 'Messenger.open', {})
    : undefined,
  id: FEATURES.GENESYS ? undefined : 'intercom_launcher',
}

const ChatDetails = () => (
  <div className={styles.intercomWrapper}>
    <div className={styles.wrapper}>
      <div className={styles.column}>
        <img
          {...chatButtonProps}
          className={styles.chatImage}
          src={FEATURES.GENESYS ? GenesysIcon : IntercomIcon}
          alt="Intercom icon"
          data-testid="intercom-icon"
        />
      </div>
      <div className={styles.column}>
        <Typography
          variant="Kollektif/SmallEmphasis"
          component="h3"
          className={styles.title}
          data-testid="chat-title"
        >
          {content.chatTitle}
        </Typography>
        <Typography
          variant="Kollektif/Small"
          component="p"
          data-testid="email-text"
          className={styles.text}
        >
          {content.emailText}
        </Typography>
        <div className={styles.buttonWrapper}>
          <Button level="tertiary" {...chatButtonProps}>
            {content.ctaText}
          </Button>
        </div>
        <Typography variant="Kollektif/Tiny" component="p">
          {content.waitTimesAndOutsideOpeningTimes}
        </Typography>
      </div>
    </div>
  </div>
)

export default ChatDetails
